import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerService } from '../../../../../../../../../services/customer/customer.service';
import { BackendEmail } from '../../../../../../../../../models/backend-email';
import { dateStringFromISO8601, timeStringFromISO8601 } from '../../../../../../../../../utils';

@Component({
  selector: 'app-backend-email-detail-modal',
  templateUrl: './backend-email-detail-modal.component.html',
  styleUrls: ['./backend-email-detail-modal.component.css']
})
export class BackendEmailDetailModalComponent implements OnInit {
  @Input() emailId: number;

  public loading = false;
  public errorMessage = '';

  public email: BackendEmail | null = null;
  public htmlContent = '';

  public dateStringFromISO8601 = dateStringFromISO8601;
  public timeStringFromISO8601 = timeStringFromISO8601;

  constructor(
    public activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.loading = true;

    this.customerService.getBackendEmail(this.emailId)
      .then(email => {
        this.email = email;
        this.htmlContent = email.html_body || '';
      })
      .catch(reason => {
        if (reason?.error?.useful_error_message) {
          this.errorMessage = reason.error.useful_error_message;
        } else {
          this.errorMessage = 'Failed to load email.';
        }
      })
      .finally(() => { this.loading = false; });
  }
}
